import { useCallback, useState, useContext } from "react";
import Cropper from "react-easy-crop";
import Modal from "../../ModalImage";
import { getCroppedImg } from "../../../utils/getCroppedImage";

const ReactEasyCrop = ({ showModal, onModalClose, imgURL, onSaveHandler, imageRatio }) => {
	const [crop, setCrop] = useState({ x: 2, y: 2 });
	const [zoom, setZoom] = useState(1);
	const [croppedArea, setCroppedArea] = useState("");

	const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
		setCroppedArea(croppedAreaPixels);
	}, []);

	const showCroppedImage = useCallback(async () => {
		try {
			const croppedImage = await getCroppedImg(imgURL, croppedArea, 0);
			return croppedImage;
		} catch (error) {
			console.error(error);
		}
	}, [croppedArea, imgURL]);

	return (
		<Modal
			showModal={showModal}
			onSaveHandler={async () => onSaveHandler(await showCroppedImage())}
			onModalClose={onModalClose}
		>
			<div className="relative w-full" style={{ width:'100%' }}>
				<Cropper
					image={imgURL}
					crop={crop}
					zoom={zoom}
					aspect={ imageRatio }
					onCropChange={setCrop}
					onCropComplete={onCropComplete}
					onZoomChange={setZoom}
				/>
			</div>
		</Modal>
	);
};

export default ReactEasyCrop;